export const css = /* css */ `
:host,
:host *,
*::before,
*::after {
  box-sizing: border-box;
}
a {
  color: inherit;
}
:not(.focus-visible),
:host(:not(.focus-visible)) {
  outline: none;
}
[hidden] {
  display: none !important;
}
:host {
  user-select: none;
  -webkit-user-select: none;
  display: inline-flex;
  align-items: stretch;
  font-size: 0;
  height: calc(var(--erem) * 2);
  height: max(calc(var(--erem) * 2), 44px);
}
:host button {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  margin: 0;
  font-family: var(--slices-text-b1--font-family, var(--slices-text-b--font-family, var(--slices-text--font-family)));
  font-size: var(--slices-text-b1--font-size);
  font-weight: var(--slices-text-b1--font-weight, var(--slices-text-b--font-weight, 400));
  line-height: var(--slices-text-b1--line-height, var(--slices-text-b--line-height));
  font-weight: var(--slices-text-h--font-weight);
  line-height: 1.2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: var(--slicesui-button-border-width, calc(var(--erem) / 16));
  border-style: solid;
  border-color: var(--slicesui-button-border-color, transparent);
  background: var(--slicesui-button-background, #000);
  color: var(--slicesui-button-color, #fff);
  padding: var(--slicesui-button-padding, 0 calc(var(--erem) * 0.5));
  border-radius: var(--slicesui-button-border-radius, 0);
}
:host button:hover:not([disabled]) {
  background: var(--slicesui-button-background--hover, var(--slicesui-button-background, #333));
  color: var(--slicesui-button-color--hover, var(--slicesui-button-color, #fff));
  border-color: var(--slicesui-button-border-color--hover, var(--slicesui-button-border-color, transparent));
}
:host button:active:not([disabled]) {
  background: var(--slicesui-button-background, #000);
  color: var(--slicesui-button-color, #fff);
}
:host button:not([disabled]) {
  cursor: pointer;
}
:host button:disabled {
  cursor: default;
  opacity: 0.5;
}
:host ::slotted(*) {
  pointer-events: none;
  font-size: var(--slices-text-b1--font-size);
}
:host ::slotted(span) {
  padding-right: calc(var(--erem) * 0.25);
}
:host([icon]) {
  width: max(calc(var(--erem) * 2), 44px);
}
:host([text]) button {
  height: auto;
  background: transparent;
  color: var(--slicesui-button-color, #000);
  padding: 0;
  border-bottom: 2px solid var(--slicesui-button-border-color, var(--slicesui-button-color, #000));
}
:host([text]) button:hover:not([disabled]),
:host([text]) button:active:not([disabled]) {
  background: transparent;
  color: var(--slicesui-button-color, #000);
}
:host([notify]) button {
  position: relative;
}
:host([notify]) button:after {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  content: '';
  animation: notify 2000ms infinite;
  border-radius: inherit;
}
@-moz-keyframes notify {
  0% {
    opacity: 1;
    background: #fff;
    transform: scale(0);
  }
  50% {
    opacity: 0;
    background: #fff;
    transform: scale(1.1);
  }
  100% {
    opacity: 0;
    background: #fff;
    transform: scale(1.1);
  }
}
@-webkit-keyframes notify {
  0% {
    opacity: 1;
    background: #fff;
    transform: scale(0);
  }
  50% {
    opacity: 0;
    background: #fff;
    transform: scale(1.1);
  }
  100% {
    opacity: 0;
    background: #fff;
    transform: scale(1.1);
  }
}
@-o-keyframes notify {
  0% {
    opacity: 1;
    background: #fff;
    transform: scale(0);
  }
  50% {
    opacity: 0;
    background: #fff;
    transform: scale(1.1);
  }
  100% {
    opacity: 0;
    background: #fff;
    transform: scale(1.1);
  }
}
@keyframes notify {
  0% {
    opacity: 1;
    background: #fff;
    transform: scale(0);
  }
  50% {
    opacity: 0;
    background: #fff;
    transform: scale(1.1);
  }
  100% {
    opacity: 0;
    background: #fff;
    transform: scale(1.1);
  }
}
`;